import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * Deletes all references to Cart from the apollo cache
 *
 * @param {ApolloClient} client
 */
export var clearCartDataFromCache = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Cached data
            client.cache.evict({
              id: 'Cart'
            }); // Cached ROOT_QUERY

            client.cache.evict({
              fieldName: 'cart'
            });
            client.cache.evict({
              fieldName: 'customerCart'
            });
            client.cache.gc();

            if (!client.persistor) {
              _context.next = 7;
              break;
            }

            _context.next = 7;
            return client.persistor.persist();

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function clearCartDataFromCache(_x) {
    return _ref.apply(this, arguments);
  };
}();